// extracted by mini-css-extract-plugin
export default {"mainLoaderHeight":"INlOn0zl1kgUbYwaL0lb"};